// a full page load drops every cache, store and socket of the previous identity
export const hardNavigate = (href: string) => {
    window.location.assign(href);
};
